import gql from "graphql-tag";

export const EDIT_COACH_INFORMATION = gql`
  mutation EditCoachInformationByUuid(
    $coachUuid: ID!
    $attribute: String!
    $value: String!
  ) {
    editCoachInformationByUuid(
      coachUuid: $coachUuid
      attribute: $attribute
      value: $value
    ) {
      coach {
        id
        timeZone
      }
      returnMessage {
        status
        message
      }
    }
  }
`;
